<template>
  <div class="image" />
</template>

<script>
export default {};
</script>

<style scoped>
.image {
  width: 100%;
  display: block;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('~@/assets/netherlands/open-market-header-mobile.webp');
  height: 180px;
}
@media (min-width: 768px) {
  .image {
    height: 351px;
    background-image: url('~@/assets/netherlands/open-market-header-desktop.webp');
  }
}
</style>
